<template>
  <div class="burerSubmitOutcome">
    <div class="burerSubmitOutcome-top">
      <div class="top-con">
        <div class="container">
          <div class="burerSubmitOutcome-title">
            买家信息表单
          </div>
          <span>订单编号：{{ order_no }}</span>
        </div>
        <div class="logo"></div>
      </div>
    </div>
    <div class="burerSubmitOutcome-main">
      <div class="burerSubmitOutcome-content">
        <div class="burerSubmitOutcome-content-img">
          <img src="@/assets/image/Contract/submitOutcome/succeed.png"/>
        </div>
        <div class="burerSubmitOutcome-content-text">
          <div>资料已成功提交</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'burerSubmitSuccess',
  data() {
    return {
      order_no: '',
    }
  },
  created() {
    this.order_no = this.$route.query.order_no
  },
  methods: {},
}
</script>

<style lang="less" scoped>
@import "./styles/contractFormPage.less";

.contract-form-page(
  72px,
  burerSubmitOutcome,
  burerSubmitOutcome-top,
  burerSubmitOutcome-main,
  burerSubmitOutcome-btn
);
.contract-feedback-layout(burerSubmitOutcome, burerSubmitOutcome-main, burerSubmitOutcome-content, 560px, 420px);

.burerSubmitOutcome {
  min-height: 100vh;

  &-title {
    font-size: 24px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    margin: 0 0 8px;
  }

  &-content {
    padding: 0 24px;

    &-img {
      img {
        display: block;
        width: 250px;
        height: 250px;
        object-fit: contain;
      }
    }

    &-text {
      margin-top: 20px;

      div {
        text-align: center;
      }

      div:first-of-type {
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: var(--text-main, #1A1D24);
        margin: 0 0 4px;
      }
    }
  }

  @media screen and (max-width: 900px) {
    &-title {
      font-size: 22px;
    }

    &-content {
      &-img {
        img {
          width: 125px;
          height: 125px;
        }
      }

      &-text {
        margin-top: 30px;

        div:first-of-type {
          font-size: 20px;
          margin: 0 0 8px;
        }
      }
    }
  }

  @media screen and (max-width: 500px) {
    &-title {
      font-size: 20px;
    }
  }
}
</style>
